import { ThreatsBreakdownView } from '../view/ThreatsBreakdownView';
import { templateThreatsBreakdown } from '../view/template';
import { ThreatsBreakdownWebComponent } from '..';
import { BaseWidgetController } from '../../widget/BaseWidgetController';
import { GetThreatsBreakdownResponse } from '@nirvana/shared/dtos/types/widgets/common';

export class ThreatsBreakdownController extends BaseWidgetController<GetThreatsBreakdownResponse> {
  public component: ThreatsBreakdownWebComponent;
  public view: ThreatsBreakdownView;
  public viewConstructor: typeof ThreatsBreakdownView;

  constructor(component: ThreatsBreakdownWebComponent) {
    super(component);
    this.initialWidgetSetup({
      viewConstructor: ThreatsBreakdownView,
      viewTemplate: templateThreatsBreakdown,
      dataFetchMethod: this.component.dependencies.api.clients.Widgets.getThreatsBreakdown,
    });
  }
}
